import React from "react";
import { Col, Row, Button } from "framework7-react";
import { fechaRecortada } from "../../../js/helpers";

const Documents = ({docs}) => {


    
  const  downloadDoc = (image, name) => {
    
        if (
          name.toUpperCase().includes(".JPG") ||
          name.toUpperCase().includes(".JPEG") ||
          name.toUpperCase().includes(".PNG")
        ) {
          var objImage = new Image();
          objImage.src = "data:image/png;base64," + image;
    
          var a = document.createElement("a");
          a.id = "doc";
          a.href = objImage.src;
          a.download = name;
          a.target = "_blank";
          a.click();
        } else {
          if (name.toUpperCase().includes(".PDF")) {
            var a = document.createElement("a");
            a.id = "doc";
            a.href = "data:application/text;base64," + image;
            a.download = name;
            a.target = "_blank";
            a.click();
          } else {
            var binary_string = window.atob(image);
            var len = binary_string.length;
            var bytes = new Array(len); //Uint8Array(len);
            var cadena = "";
            for (var i = 0; i < len; i++) {
              cadena = cadena + binary_string.charCodeAt(i);
              bytes[i] = binary_string.charCodeAt(i);
            }
            var blob = new Blob([bytes], {
              type: "application/text",
            });
            var a = document.createElement("a");
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = name;
            a.click();
          }
        }
      }
    

    if (docs.length >= 1){
      return docs.map((document)=>{
        if (document.idTypeDocumentation == 3){
          return(
            <div>
                  <Row>
                      <Col width="35" className='light center '>{document.descDocumentation}</Col>
                      <Col width="35" className='light recDate center ' id="contractDate">{fechaRecortada(document.receptionDate)}</Col>
                      <Col width="30" className='center large'><Button tonal iconF7='arrow_down_square' className="btnDoc" id="downCon" onClick={() => downloadDoc(document.image,document.fileName)}></Button></Col>
                  </Row>
                  <br />
            </div>
          )
        }
        return null;
      })
    }
    return null;
          
            

}; export default Documents;